import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

const resetOldServiceWorkers = () => {
  void navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      void registration.unregister()
    })
  })
  if ('caches' in window) {
    void caches.keys().then((cacheNames) => {
      cacheNames.forEach((cacheName) => {
        void caches.delete(cacheName)
      })
    })
  }
}

if ('serviceWorker' in navigator) resetOldServiceWorkers()

createRoot(document.getElementById("root")!).render(<App />);
